<template>
  <path
    d="M19 5.00018H5C3.9 5.00018 3 5.90018 3 7.00018V17.0002C3 18.1002 3.9 19.0002 5 19.0002H19C20.1 19.0002 21 18.1002 21 17.0002V7.00018C21 5.90018 20.1 5.00018 19 5.00018ZM18 17.0002H6C5.45 17.0002 5 16.5502 5 16.0002V8.00018C5 7.45018 5.45 7.00018 6 7.00018H18C18.55 7.00018 19 7.45018 19 8.00018V16.0002C19 16.5502 18.55 17.0002 18 17.0002Z"
  />
</template>
